//Dependecies
import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { reducer as toastrReducer} from 'react-redux-toastr';
//Reducers
import appReducer from './AppReducer';
import drawerReducer from './DrawersReducer';
import mapReducer from './MapReducer';
import modalsReducer from './ModalsReducer';
import portfolioReducer from './PortfolioReducer';
import toursReducer from './ToursReducer';

const RootReducer = combineReducers(
{
  app             : appReducer,
  drawers         : drawerReducer,
  map             : mapReducer,
  modals          : modalsReducer,
  portfolio       : portfolioReducer,
  tours           : toursReducer,
  
  firebase        : firebaseReducer,
  toastr          : toastrReducer,
});

export default RootReducer;